/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{ "rawString": ".root_8eab4ccb{position:relative;font-size:12px;background:" }, { "theme": "listBackground", "defaultValue": "#ffffff" }, { "rawString": ";color:" }, { "theme": "listText", "defaultValue": "#333333" }, { "rawString": "}.focusZone_8eab4ccb{display:inline-block;min-width:100%;min-height:1px}.rootIsHorizontalConstrained_8eab4ccb{overflow-x:auto;overflow-y:visible;-webkit-overflow-scrolling:touch}.root_8eab4ccb .ms-List-cell{min-height:38px;word-break:break-word}.rootCompact_8eab4ccb .ms-List-cell{min-height:32px}\n" }]);
export var root = "root_8eab4ccb";
export var focusZone = "focusZone_8eab4ccb";
export var rootIsHorizontalConstrained = "rootIsHorizontalConstrained_8eab4ccb";
export var rootCompact = "rootCompact_8eab4ccb";
//# sourceMappingURL=DetailsList.scss.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/DetailsList/DetailsList.scss.js
// module id = 396
// module chunks = 0